module.exports = __webpack_public_path__ + "assets/SS_grommet.96bb95f8.svg";